import React, { useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { API_URL, pathHomePage, pathTherapistHome, pathPatientHome, pathRegister } from "../../config/constants";
import { authenticateSocket } from "../../socket";
import TopBar from "../../components/TopBar";
import {
  Container, Card, CardTitle, Form,
  Field, Label, Input, SubmitButton, ErrorMsg, LinkText,
} from "./styles";

const Login = () => {
  const { t } = useTranslation();
  const history = useHistory();
  const [form, setForm] = useState({ username: "", password: "" });
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError("");
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const res = await fetch(`${API_URL}/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(form),
      });
      const text = await res.text();
      let data;
      try { data = JSON.parse(text); } catch { throw new Error(t("auth.serverError")); }
      if (!res.ok) throw new Error(data.error);
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      authenticateSocket(); // el socket ya estaba conectado sin token
      if (data.user.role === "therapist") history.push(pathTherapistHome);
      else if (data.user.role === "patient") history.push(pathPatientHome);
      else history.push(pathHomePage);
    } catch (err) {
      setError(err.message || t("auth.loginError"));
    } finally {
      setLoading(false);
    }
  };

  return (
    <Container>
      <TopBar />
      <Card>
        <CardTitle>{t("auth.signIn")}</CardTitle>
        <Form onSubmit={handleSubmit}>
          <Field>
            <Label>{t("auth.username")}</Label>
            <Input
              type="text"
              name="username"
              placeholder={t("auth.usernamePlaceholder")}
              value={form.username}
              onChange={handleChange}
              required
            />
          </Field>
          <Field>
            <Label>{t("auth.password")}</Label>
            <Input
              type="password"
              name="password"
              placeholder="••••••••••••"
              value={form.password}
              onChange={handleChange}
              required
            />
          </Field>
          {error && <ErrorMsg>{error}</ErrorMsg>}
          <SubmitButton type="submit" disabled={loading}>
            {loading ? t("auth.signingIn") : t("auth.signIn")}
          </SubmitButton>
        </Form>
        <LinkText>
          {t("auth.noAccount")} <Link to={pathRegister}>{t("auth.register")}</Link>
        </LinkText>
      </Card>
    </Container>
  );
};

export default Login;
